import React, { Component } from 'react';
import { Router /*, Link */ } from '@reach/router';
import { withStyles } from '@material-ui/core/styles';
import Login from './components/login';
import ConsolePage from './components/console';

const styles = theme => ({
  gradient: {
    backgroundImage: 'linear-gradient(135deg, white, #dedede)',
    minWidth: '100vw',
    minHeight: '100vh',
  },
});

const Console = () => <div>
  <div>
    <ConsolePage />
  </div>
</div>;

class App extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.gradient}>
        <Router>
          <Login path='/' />
          <Console path="/console" />
        </Router>
      </div>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js